module.exports = __webpack_public_path__ + "iPad_pro.svg?fce8f5f867c48dc407f3370ec0802193";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPad_pro.svg
// module id = 224
// module chunks = 0